import { generateTestId } from "@client-shared";

export const setSalesTrendChartTestId = (identifier: string): string =>
  generateTestId("SalesTrendChart", identifier);

// Specific testId setters for tests
export const setSalesTrendChartContainerTestId = (): string =>
  setSalesTrendChartTestId("container");
export const setSalesTrendChartTitleTestId = (): string =>
  setSalesTrendChartTestId("title");
